import { Icon } from '@scuf/common';
import React, { FunctionComponent} from 'react';
import './Collapsible.scss';
import { ICollapsibleProps } from './ICollapsibleProps';

/* Component for expand and collapse using an accordion. Added transition to provide a smooth user experience. */
export const Collapsible: FunctionComponent<ICollapsibleProps> = (props) => {
    //  const [open, setOpen] = useState(false); // Expand or collapsed status flag
    const handleOnclick = () => {//@ts-ignore
         props.setshowModal()
       }
    return (
        <div className="collapsible">
            <div className="collapsible__header" onClick={handleOnclick}>
                <div className="collapsible__header--title">
                    {props.title}
                </div>
                <div className="collapsible__header--icon">
                    {props.iconExactSize? 
                        <Icon root="common" name={props.showModal ? 'caret-up' : 'caret-down'} exactSize={props.iconExactSize}/>
                    :
                        <Icon root="common" name={props.showModal ? 'caret-up' : 'caret-down'} size="small"/>
                    }
                    
                </div>
            </div>
            <div className={`collapsible__content ${props.showModal ? 'open' : ''}`} >
                {props.children}
            </div>
        </div>
    );
};